export const actionTypes = {
    CLEAN_STATE: 'CLEAN_STATE',
    FETCH_CHARACTERS: 'FETCH_CHARACTERS',
    FETCH_CHARACTER: 'FETCH_CHARACTER',
    FETCH_ONE_CHARACTER: 'FETCH_ONE_CHARACTER',
    LOCAL_STORAGE_CHARACTER: 'LOCAL_STORAGE_CHARACTER',
    LOCAL_STORAGE_DELETE: 'LOCAL_STORAGE_DELETE',
    SEARCH_CHARACTER: 'SEARCH_CHARACTER',
    PAGINATION_CHARACTER: 'PAGINATION_CHARACTER',
}